<template>
    <div class="row g-3">
        <div class="col-12 col-sm-4 col-xl-3" style="text-transform: capitalize;">
            <span>{{ item.month }} {{ item.year }}</span>
        </div>
        <div class="col-sm-13 col-xl-8 d-none d-sm-flex">
            <span v-if="item.sum_monthly">Månadskostnad </span>
            <span v-if="item.subscription.type === 'pay_per_treatment'">Månadens behandlingar </span>
            <span v-if="item.start_fee">och startavgift </span>
            <span v-if="item.sum_monthly && item.sum_settlement">. </span>
            <span v-if="item.sum_settlement"> Avräkning för {{ item.period_settlement.from_date }} till {{ item.period_settlement.to_date }}. </span>
            <span v-if="show_workplace_fee_text"><span style="color:#888; font-size: 0.875rem;">Kostnad per digital bokningskalender tillkommer.</span></span>

        </div>
        <div class="col-xl-3 d-none d-xl-flex">
            <span v-if="item.sum_monthly">{{ item.sum_monthly }} kr</span>
        </div>
        <div class="col-xl-4 d-none d-xl-flex">
            <span v-if="item.start_fee">Startavg: {{ item.start_fee }} kr</span>
            <span v-if="item.sum_settlement">{{ item.num_settlement_treatments }} extra behandlingar: {{ item.sum_settlement }} kr</span>
            <span v-if="item.sum_no_show">{{ item.num_no_show_treatments }} sena avbokningar eller no shows á {{ item.sum_no_show }} kr</span>
            <span v-if="item.subscription.type === 'pay_per_treatment'">{{ item.num_total_treatments }} behandlingar</span>
        </div>
        <div class="col-xl-4 d-none d-xl-flex">
            <span v-if="item.sum_settlement || item.sum_no_show || item.subscription.type === 'pay_per_treatment'">
                <a target="_blank" :href="item.company_portal_url_pdf">
                    <img class="download-icon" src="/images/company-portal/icon-download.svg">Specifikation
                </a>
            </span>
        </div>
        <div class="col-8 col-sm-3 col-xl-2">
            <span><b>{{ item.sum_total }} kr</b></span>
        </div>
        <div class="col-4 col-sm-4 d-flex d-xl-none justify-content-end">
            <div class="fold-arrow"
                 @click="foldRow = !foldRow"
                 :class="{ 'folded' : foldRow == true }">
                 <img class="arrow-icon" src="/images/company-portal/icon-arrow.svg">
            </div>
        </div>
        <div class="col-24 mt-4"
             :class="{ 'd-none' : foldRow != true }"
             style="border-top:1px solid #efefef;">
            <div class="row py-3">
                <div class="col-24 mb-1" v-if="item.sum_settlement">
                    <span v-if="item.sum_settlement">Avräkning för {{ item.period_settlement.from_date }} till {{ item.period_settlement.to_date }}.</span>

                </div>

                <div class="col-16 mb-1" v-if="item.sum_monthly">
                    Månadskostnad
                </div>
                <div class="col-8 d-flex justify-content-end mb-1" v-if="item.sum_monthly">
                    <span>{{ item.sum_monthly }} kr</span>
                </div>

                <div class="col-16 mb-1" v-if="item.num_total_treatments">
                    Månadens behandlingar
                </div>
                <div class="col-8 d-flex justify-content-end mb-1" v-if="item.num_total_treatments">
                    <span>{{ item.num_total_treatments }} behandlingar</span>
                </div>

                <div class="col-16 mb-1" v-if="item.start_fee">
                    Startavgift
                </div>
                <div class="col-8 d-flex justify-content-end mb-1" v-if="item.start_fee">
                    {{ item.start_fee }} kr
                </div>
                <div class="col-16 mb-1">
                    <span v-if="item.sum_settlement">
                        {{ item.num_settlement_treatments }} extra behandlingar
                    </span>
                </div>
                <div class="col-8 d-flex justify-content-end mb-1">
                    <span v-if="item.sum_settlement">
                        {{ item.sum_settlement }} kr
                    </span>
                </div>
                <div class="col-16 mb-5">
                    <b>Totalt</b>
                </div>
                <div class="col-8 d-flex justify-content-end mb-5">
                    <b>{{ item.sum_total }} kr</b>
                </div>
                <div class="col-24 mb-5" v-if="show_workplace_fee_text">
                    <span style="color:#888; font-size: 0.925rem;">Kostnad per digital bokningskalender tillkommer.</span>
                </div>
                <div class="col-24">
                    <span v-if="item.sum_settlement !== 0 || item.sum_no_show ||  item.subscription.type === 'pay_per_treatment'">
                        <a target="_blank" :href="item.company_portal_url_pdf">
                            <img class="download-icon" src="/images/company-portal/icon-download.svg">Specifikation
                        </a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        item: {
            required: true
        },
        show_workplace_fee_text: {
            required: true
        }
    },

    data () {
        return {
            foldRow: false
        }
    }
}
</script>
